__turbopack_context__.v({
  "order_info_item": "order-info-item-module-scss-module__3i3EZa__order_info_item",
  "order_info_item__item_name": "order-info-item-module-scss-module__3i3EZa__order_info_item__item_name",
  "order_info_item__item_value": "order-info-item-module-scss-module__3i3EZa__order_info_item__item_value",
  "order_info_item_accent": "order-info-item-module-scss-module__3i3EZa__order_info_item_accent",
  "order_info_item_big": "order-info-item-module-scss-module__3i3EZa__order_info_item_big",
});
